export default "__VITE_ASSET__8Hma$ehn__"